import React from 'react';

import Header from 'shared/components/Header';
// import Footer from 'shared/components/Footer';

interface AppShellProps {
  children: React.ReactNode;
  /** When true, expands the content container for dashboard-style steps. */
  wide?: boolean;
  /** When true, removes the inner max-width container so children can span full width. */
  fullBleed?: boolean;
  /** When true, lets a page render its own marketing header. */
  hideHeader?: boolean;
  /**
   * Optional bar rendered directly below the top Header. Spans the full viewport
   * width and sticks to the top of the page (just under the 64px Header) on scroll.
   */
  stickyBar?: React.ReactNode;
}

const AppShell: React.FC<AppShellProps> = ({
  children,
  wide = false,
  fullBleed = false,
  hideHeader = false,
  stickyBar,
}) => {
  return (
    <div className="relative min-h-screen flex flex-col overflow-x-clip bg-white">
      {!hideHeader && <Header />}
      {stickyBar && (
        <div className="sticky top-16 z-40 w-full bg-white border-b border-gray-200 shadow-sm">
          {stickyBar}
        </div>
      )}
      <main className="relative flex-1 w-full">
        {fullBleed ? (
          children
        ) : (
          <div
            className={`${wide ? 'max-w-6xl' : 'max-w-3xl'} mx-auto px-4 sm:px-6 py-6 sm:py-10`}
          >
            {children}
          </div>
        )}
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default AppShell;
